<template>
  <div id="editSub" style="background: white">
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <br />
    <div style="width: 100%">
      <div style="width: 30%; float: left">
        <img
          :src="productImageUrl"
          alt=""
          class="productImageOnEditSubscription"
        />
      </div>
      <div style="width: 65%; float: right; margin-top: 30px">
        <div style="margin-right: 7px">
          <b>{{ productName }}</b
          ><br />
          <i style="color: gray; font-size: 13px">{{
            productShortDescription
          }}</i
          ><br />
        </div>
      </div>
    </div>
    <div style="clear: both"></div>
    <!-- <div class="leftMargin colorDesc topMarginHalf" v-on:click="descriptionClick($event)" style="width: 90%;">
      <b-collapse :open="false" class="show panel">
        <div slot="trigger" style="color: black !important;" class="panel-heading collapseheaderClass" role="button">
          Description<i v-if="descAngleDown === true" class="fa fa-angle-down" style="float: right;"></i><i v-else
            class="fa fa-angle-up" style="float: right;"></i>
        </div>
        <div id="collapseContent" style="width: 88%; text-align: justify; margin-left: 6%; color: #5f5c5c;">
          {{ productLongDescription }}
        </div>
      </b-collapse>
    </div> -->
    <div class="leftMargin topMarginHalf">
      <div style="width: 30%; float: left">Produced By</div>
      <div style="width: 70%; float: left">: {{ brandName }}</div>
      <div style="clear: both"></div>
    </div>
    <div v-if="isPostpaidDisabled === true" class="leftMargin topMarginHalf">
      <div style="width: 30%; float: left">Price</div>
      <div style="width: 70%; float: left">
        :
        <span v-if="cutPrice === false" style="font-size: 1rem">
          <i class="fa fa-rupee"></i
          >{{ prepaidProductPriceObj.prepaidPrice }}/{{
            prepaidProductPriceObj.prodQuantity
          }}
          {{ prepaidProductPriceObj.prodUnit }}
        </span>
        <span v-else-if="promoCodeVerified === true" style="font-size: 1rem">
          <span style="text-decoration: line-through; color: red"
            ><i class="fa fa-rupee"></i
            >{{ prepaidProductPriceObj.prepaidPrice }}</span
          ><span
            ><i class="fa fa-rupee"></i
            >{{
              (
                prepaidProductPriceObj.prepaidPrice - directLinkOfferedDiscount
              ).toFixed(2)
            }}</span
          >/{{ prepaidProductPriceObj.prodQuantity }}
          {{ prepaidProductPriceObj.prodUnit }}
        </span>
        <span v-else style="font-size: 1rem">
          <span
            style="font-size: 13px; text-decoration: line-through; color: red"
            ><i class="fa fa-rupee"></i
            >{{ prepaidProductPriceObj.prepaid_price_without_offer }}/{{
              prepaidProductPriceObj.prodQuantity
            }}
            {{ prepaidProductPriceObj.prodUnit }}</span
          ><br />
          <span style="font-size: 13px"
            ><i class="fa fa-rupee"></i
            >{{ prepaidProductPriceObj.prepaidPrice }}/{{
              prepaidProductPriceObj.prodQuantity
            }}
            {{ prepaidProductPriceObj.prodUnit }}</span
          >
        </span>
      </div>
      <div style="clear: both"></div>
    </div>
    <div v-else class="leftMargin topMarginHalf">
      <div>Choose Payment Plan</div>
      <div class="topMarginHalf columns is-mobile">
        <div class="column is-7">
          <b-checkbox
            id="postpaidB"
            v-model="postpaidCheckbox"
            type=""
            @click.native="paymentMode"
            disabled
          >
            Postpaid
          </b-checkbox>
          <br />
          <span v-if="cutPrice === false" style="font-size: 13px"
            ><i class="fa fa-rupee"></i
            >{{ prepaidProductPriceObj.postpaidPrice }}/{{
              prepaidProductPriceObj.prodQuantity
            }}
            {{ prepaidProductPriceObj.prodUnit }}</span
          >
          <span v-else-if="promoCodeVerified === true">
            <span
              style="font-size: 13px; text-decoration: line-through; color: red"
              ><i class="fa fa-rupee"></i
              >{{ prepaidProductPriceObj.postpaidPrice }}/{{
                prepaidProductPriceObj.prodQuantity
              }}
              {{ prepaidProductPriceObj.prodUnit }}</span
            ><br />
            <span style="font-size: 13px"
              ><i class="fa fa-rupee"></i
              >{{
                (
                  prepaidProductPriceObj.postpaidPrice -
                  directLinkOfferedDiscount
                ).toFixed(2)
              }}/{{ prepaidProductPriceObj.prodQuantity }}
              {{ prepaidProductPriceObj.prodUnit }}</span
            >
          </span>
          <span v-else>
            <span
              style="font-size: 13px; text-decoration: line-through; color: red"
              ><i class="fa fa-rupee"></i
              >{{ prepaidProductPriceObj.postpaid_price_without_offer }}/{{
                prepaidProductPriceObj.prodQuantity
              }}
              {{ prepaidProductPriceObj.prodUnit }}</span
            ><br />
            <span style="font-size: 13px"
              ><i class="fa fa-rupee"></i
              >{{ prepaidProductPriceObj.postpaidPrice }}/{{
                prepaidProductPriceObj.prodQuantity
              }}
              {{ prepaidProductPriceObj.prodUnit }}</span
            >
          </span>
        </div>
        <div class="column is-5">
          <b-checkbox
            id="prepaidB"
            v-model="prepaidCheckbox"
            type=""
            @click.native="paymentMode"
            disabled
          >
            Prepaid </b-checkbox
          ><br />
          <span v-if="cutPrice === false" style="font-size: 13px"
            ><i class="fa fa-rupee"></i
            >{{ prepaidProductPriceObj.prepaidPrice }}/{{
              prepaidProductPriceObj.prodQuantity
            }}
            {{ prepaidProductPriceObj.prodUnit }}</span
          >
          <span v-else-if="promoCodeVerified === true">
            <span
              style="font-size: 13px; text-decoration: line-through; color: red"
              ><i class="fa fa-rupee"></i
              >{{ prepaidProductPriceObj.prepaidPrice }}/{{
                prepaidProductPriceObj.prodQuantity
              }}
              {{ prepaidProductPriceObj.prodUnit }}</span
            ><br />
            <span style="font-size: 13px"
              ><i class="fa fa-rupee"></i
              >{{
                (
                  prepaidProductPriceObj.prepaidPrice -
                  directLinkOfferedDiscount
                ).toFixed(2)
              }}/{{ prepaidProductPriceObj.prodQuantity }}
              {{ prepaidProductPriceObj.prodUnit }}</span
            >
          </span>
          <span v-else>
            <span
              style="font-size: 13px; text-decoration: line-through; color: red"
              ><i class="fa fa-rupee"></i
              >{{ prepaidProductPriceObj.prepaid_price_without_offer }}/{{
                prepaidProductPriceObj.prodQuantity
              }}
              {{ prepaidProductPriceObj.prodUnit }}</span
            ><br />
            <span style="font-size: 13px"
              ><i class="fa fa-rupee"></i
              >{{ prepaidProductPriceObj.prepaidPrice }}/{{
                prepaidProductPriceObj.prodQuantity
              }}
              {{ prepaidProductPriceObj.prodUnit }}</span
            >
          </span>
        </div>
      </div>
    </div>

    <div style="clear: both"></div>
    <!-- <hr v-if="subscriptionTypeOneTime === false" class="leftMargin topMargin" style="width: 90%;"> -->
    <div v-if="subscriptionTypeOneTime === false" class="leftMargin">
      <span style="font-size: 12px; color: gray">{{
        displayPromocodeText
      }}</span>
      <hr class="topMargin" style="width: 90%" />
    </div>
    <div v-if="subscriptionTypeDaily === true" class="leftMargin">
      <div>Choose Delivery Schedule</div>
      <div class="topMarginHalf columns is-mobile">
        <div class="column is-7">
          <b-checkbox
            id="everydayid"
            v-model="everydayCheckbox"
            type=""
            @click.native="schedulePlan"
            disabled
          >
            Everyday
          </b-checkbox>
        </div>
        <div
          v-if="
            isEditSubscription === false &&
            (productId == 128 || productId == 129 || productId == 151)
          "
          class="column is-5"
        ></div>
        <div v-else class="column is-5">
          <b-checkbox
            id="customizeid"
            v-model="customizeCheckbox"
            type=""
            @click.native="schedulePlan"
            disabled
          >
            Customize
          </b-checkbox>
        </div>
      </div>
      <div class="columns is-mobile">
        <div class="column is-7">
          <b-checkbox
            id="alternateid"
            v-model="alternateCheckbox"
            type=""
            @click.native="schedulePlan"
            disabled
          >
            Alternate
          </b-checkbox>
        </div>
      </div>
    </div>
    <div v-if="subscriptionTypeBoth === true" class="leftMargin">
      <div>Choose Delivery Schedule</div>
      <div class="topMarginHalf columns is-mobile">
        <div class="column is-7">
          <b-checkbox
            id="everydayid"
            v-model="everydayCheckbox"
            type=""
            @click.native="schedulePlan"
            disabled
          >
            Everyday
          </b-checkbox>
        </div>
        <div
          v-if="
            isEditSubscription === false &&
            (productId == 128 || productId == 129 || productId == 151)
          "
          class="column is-5"
        ></div>
        <div v-else class="column is-5">
          <b-checkbox
            id="customizeid"
            v-model="customizeCheckbox"
            type=""
            @click.native="schedulePlan"
            disabled
          >
            Customize
          </b-checkbox>
        </div>
      </div>
      <div class="columns is-mobile">
        <div class="column is-7">
          <b-checkbox
            id="alternateid"
            v-model="alternateCheckbox"
            type=""
            @click.native="schedulePlan"
            disabled
          >
            Alternate
          </b-checkbox>
        </div>
        <!--div class="column is-5">
            <b-checkbox id="onetimeid" v-model="onetimeCheckbox"
              type="" @click.native="schedulePlan" disabled>
                  Buy Once
            </b-checkbox>
        </div-->
      </div>
    </div>
    <div
      v-if="subscriptionTypeOneTime === true"
      class="leftMargin bottomMargin"
    >
      <span style="font-size: 12px; color: gray">{{
        displayPromocodeText
      }}</span>
      <div class="topMarginHalf" style="width: 30%; float: left">
        Delivered On
      </div>
      <div class="topMarginHalf" style="width: 70%; float: left">
        :
        <date-pick
          v-if="isEditSubscription === false"
          :inputAttributes="{
            style: {
              border: '0',
              'border-bottom': '1px solid',
              color: 'blue',
              'text-align': 'center',
              'margin-left': '5%',
              width: '70%',
            },
          }"
          v-model="subDate"
          :displayFormat="'DD-MM-YYYY'"
          :isDateDisabled="isPastDate"
        ></date-pick>
        <span
          v-else
          style="text-align: center; color: gray; margin-left: 5%; width: 50%"
          >{{ displayedDate }}</span
        >
      </div>
      <div style="clear: both"></div>

      <!-- Delivered On : 
      <date-pick :inputAttributes= "{'style': {'border': '0','border-bottom': '1px solid','color':'blue','text-align': 'center','margin-left':'5%','width':'70%'}}" v-model="subDate" :displayFormat="'DD-MM-YYYY'" :isDateDisabled="isPastDate"></date-pick> -->
    </div>
    <div v-else class="leftMargin topMarginHalf" style="font-size: 16px">
      Starting On :
      <!-- <date-pick v-model="date" :displayFormat="'DD-MM-YYYY'" :editable="false"></date-pick> -->
      <date-pick
        v-if="isEditSubscription === false"
        :inputAttributes="{
          style: {
            border: '0',
            'border-bottom': '1px solid',
            color: 'blue',
            'text-align': 'center',
            'margin-left': '5%',
            width: '70%',
            'font-size': '14px',
          },
        }"
        v-model="subDate"
        :displayFormat="'DD-MM-YYYY'"
        :isDateDisabled="isPastDate"
      ></date-pick>
      <span
        v-else
        style="text-align: left; color: gray; margin-left: 5%; width: 50%"
        >{{ displayedDate }}</span
      >
      <!-- <span class="rightMargin" style="float: right;">Every Second Day</span> -->
      <select
        v-if="alternateDisplay === true"
        style="
          float: right;
          border: 0px;
          color: blue;
          background: white;
          margin-right: 10%;
        "
        v-model="selectedAlternate"
      >
        <option v-for="option in alternateOptions" v-bind:value="option.value">
          {{ option.text }}
        </option>
      </select>
      <div v-if="customizeDisplay === true" class="topMargin">
        <div style="width: 100%">
          <div v-if="fillSunColor === true" class="customizedays">
            <div
              id="sun"
              style="
                width: 58%;
                background: #3cb6c3;
                border-radius: 50%;
                color: white;
              "
              v-on:click="customizeDivColor($event)"
            >
              S
            </div>
            <div style="width: 58%">{{ sunQty }}</div>
          </div>
          <div v-else class="customizedays">
            <div
              id="sun"
              class="customizedaycss"
              v-on:click="customizeDivColor($event)"
            >
              S
            </div>
            <div style="width: 58%">{{ sunQty }}</div>
          </div>
          <div class="customizedays">
            <div
              id="mon"
              class="customizedaycss"
              v-on:click="customizeDivColor($event)"
            >
              M
            </div>
            <div style="width: 58%">{{ monQty }}</div>
          </div>
          <div class="customizedays">
            <div
              id="tue"
              class="customizedaycss"
              v-on:click="customizeDivColor($event)"
            >
              T
            </div>
            <div style="width: 58%">{{ tueQty }}</div>
          </div>
          <div class="customizedays">
            <div
              id="wed"
              class="customizedaycss"
              v-on:click="customizeDivColor($event)"
            >
              W
            </div>
            <div style="width: 58%">{{ wedQty }}</div>
          </div>
          <div class="customizedays">
            <div
              id="thu"
              class="customizedaycss"
              v-on:click="customizeDivColor($event)"
            >
              T
            </div>
            <div style="width: 58%">{{ thuQty }}</div>
          </div>
          <div class="customizedays">
            <div
              id="fri"
              class="customizedaycss"
              v-on:click="customizeDivColor($event)"
            >
              F
            </div>
            <div style="width: 58%">{{ friQty }}</div>
          </div>
          <div class="customizedays">
            <div
              id="sat"
              class="customizedaycss"
              v-on:click="customizeDivColor($event)"
            >
              S
            </div>
            <div style="width: 58%">{{ satQty }}</div>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>
    </div>
    <div class="topMargin" style="text-align: center">
      <vue-numeric-input
        class="plusMinus"
        v-if="customizeDisplay === true"
        size="90px"
        align="center"
        v-model="quantityValue"
        :min="0"
        :max="maxQuantity"
        :step="1"
        v-on:change="changeQuantity"
      ></vue-numeric-input>

      <vue-numeric-input
        class="plusMinus"
        v-else-if="
          isEditSubscription === false &&
          (productId == 128 || productId == 129 || productId == 151)
        "
        size="90px"
        align="center"
        v-model="quantityValue"
        :min="2"
        :max="maxQuantity"
        :step="1"
        v-on:change="changeQuantity"
      ></vue-numeric-input>

      <vue-numeric-input
        class="plusMinus"
        v-else
        size="90px"
        align="center"
        v-model="quantityValue"
        :min="1"
        :max="maxQuantity"
        :step="1"
        v-on:change="changeQuantity"
      ></vue-numeric-input>
      <div style="text-align: center; font-size: 12px; margin-top: 0.2rem">
        Add Quantity
      </div>
    </div>
    <hr class="leftMargin topMargin" style="width: 90%" />

    <div align="center" v-if="promoCodeVerifiedDirectLink === false">
      <div
        class="topMargin"
        style="text-align: center"
        v-if="closePromo === true"
        id="closePromocode"
        v-on:click="promocode($event)"
      >
        <u
          id="closePromocode1"
          v-on:click="promocode($event)"
          style="color: blue"
          >Apply Promocode</u
        >
      </div>

      <div class="row" id="row1 col-md-6" v-else style="width: 100%">
        <div class="col-md-3"></div>
        <div class="col-md-6" id="md6" align="center">
          <input
            v-if="promoCodeVerified === false"
            class="placedPromocode"
            style="
              text-align: left;
              border: 1px solid gray;
              width: 48%;
              line-height: 1.8rem;
              border: none;
              border-bottom: 1px solid #3cb6c3;
            "
            v-model="promocodeText"
            placeholder="Enter Promocode"
          />

          <input
            v-else
            style="text-align: center; border: 1px solid gray"
            v-model="promocodeText"
            placeholder=""
            readonly="true"
          /><i
            v-on:click="checkPromoValid()"
            style="
              color: white;
              margin-left: 5px;
              margin-right: 5px;
              line-height: 1.8rem;
              font-weight: bold;
              font-style: normal;
              width: 65px;
            "
            class="mat-raised-button btn btn-info btn-md buttonOnEditSubscription mobile-view"
            >Apply</i
          >
          <i
            id="openPromocode"
            v-on:click="promocode($event)"
            style="
              color: white;
              line-height: 1.8rem;
              font-weight: bold;
              font-style: normal;
              width: 65px;
            "
            class="mat-raised-button btn btn-info btn-md buttonOnEditSubscription mobile-view"
            >Cancel</i
          ><br />
          <div v-if="promoCodeSuccess === true" style="">
            <img
              src="../../../../static/img/right_check.png"
              class="topMarginHalf promoSuccessFailClass"
              style=""
            /><br />
            <span
              class="topMarginHalf"
              style="color: #3cb6c3; font-size: 10px"
              >{{ promoCodeVerifyMsg }}</span
            >
          </div>
          <div v-if="promoCodeFailed === true" style="">
            <img
              src="../../../../static/img/cross_check.png"
              class="topMarginHalf promoSuccessFailClass"
              style=""
            /><br />
            <span
              class="topMarginHalf"
              style="color: #3cb6c3; font-size: 10px"
              >{{ promoCodeVerifyMsg }}</span
            >
          </div>
        </div>

        <div class="col-md-3"></div>
      </div>

      <!-- <div class="topMargin" style="text-align: center;" v-else>
        <u id="openPromocode" v-on:click="promocode($event)" style="color: blue;">cancel</u>
        <div class="topMargin" style="width: 100%;">
          <div style="margin-left: 25%; width: 50%; float: left;">
            <input v-if="promoCodeVerified === false" style="text-align: center; border: 1px solid gray;"
              v-model="promocodeText" placeholder="">
            <input v-else style="text-align: center; border: 1px solid gray;" v-model="promocodeText" placeholder=""
              readonly="true">
          </div>
          <div style="width: 25%; float: right;">
            <u v-on:click="checkPromoValid();" style="color: blue;">Apply</u>
          </div>
          <div style="clear: both;"></div>
        </div>
        <div v-if="promoCodeSuccess === true" v-on:click="" style="">
          <img src="../../../../static/img/right_check.png" class="topMarginHalf promoSuccessFailClass" style=""><br>
          <span class="topMarginHalf" style="color: #3CB6C3; font-size: 10px;">{{ promoCodeVerifyMsg }}</span>
        </div>
        <div v-if="promoCodeFailed === true" v-on:click="" style="">
          <img src="../../../../static/img/cross_check.png" class="topMarginHalf promoSuccessFailClass" style=""><br>
          <span class="topMarginHalf" style="color: #3CB6C3; font-size: 10px;">{{ promoCodeVerifyMsg }}</span>
        </div>
      </div> -->
    </div>
    <div
      class="topMargin"
      style="text-align: center"
      v-if="closeNiceTohave === true"
      id="closeNiceToHaveRequest"
      v-on:click="nicetohavereq($event)"
    >
      <i
        id="closeNiceToHaveRequest1"
        v-on:click="nicetohavereq($event)"
        style="color: blue"
        >+ Add nice to have request</i
      >
    </div>
    <div class="topMargin" style="text-align: center" v-else>
      <i
        id="openNiceToHaveRequest"
        v-on:click="nicetohavereq($event)"
        style="color: blue"
        >- Add nice to have request</i
      >
      <div class="topMargin leftMargin">
        <input
          style="text-align: left; border: 1px solid gray; width: 74%"
          v-model="nicetohavereqText"
          placeholder=""
        />
      </div>
    </div>
    <div class="topMargin leftMargin" style="text-align: center">
      <div>Ring the bell or Not?</div>
      <div style="width: 49.35%; float: left">
        <div
          v-if="ringOnNotSelected === true"
          v-on:click="bellStatusChange($event)"
          id="ring_on_not_selected"
          style="float: right"
        >
          <img
            v-on:click="bellStatusChange($event)"
            id="ring_on_not_selected"
            src="../../../../static/img/ring_on_not_selected.png"
            style="width: 37%"
          />
        </div>
        <div
          v-if="ringOnSelected === true"
          v-on:click="bellStatusChange($event)"
          id="ring_on_selected"
          style="float: right"
        >
          <img
            v-on:click="bellStatusChange($event)"
            id="ring_on_selected"
            src="../../../../static/img/ring_on_selected.png"
            style="width: 37%"
          />
        </div>
      </div>
      <div
        style="width: 0.3%; float: left; background: gray; height: 40px"
      ></div>
      <div style="width: 49.35%; float: right">
        <div
          v-if="ringOffNotSelected === true"
          v-on:click="bellStatusChange($event)"
          id="ring_off_not_selected"
          style="float: left"
        >
          <img
            v-on:click="bellStatusChange($event)"
            id="ring_off_not_selected"
            src="../../../../static/img/ring_off_not_selected.png"
            style="width: 37%"
          />
        </div>
        <div
          v-if="ringOffSelected === true"
          v-on:click="bellStatusChange($event)"
          id="ring_off_selected"
          style="float: left"
        >
          <img
            v-on:click="bellStatusChange($event)"
            id="ring_off_selected"
            src="../../../../static/img/ring_off_selected.png"
            style="width: 37%"
          />
        </div>
      </div>
      <div class="bottomMargin" style="clear: both"></div>
    </div>
    <div style="clear: both"></div>
    <div style="bottom: 0; position: sticky">
      <div style="height: 10px; background-color: white"></div>
      <div>
        <!-- <input class="buttonOnEditSubscription" value="CONTINUE" type="button" v-on:click="subscriptionVerification();"> -->
        <input
          class="buttonOnEditSubscription"
          value="CONTINUE"
          type="button"
          v-on:click="isServicePincode()"
        />
      </div>
    </div>
  </div>
</template>
<script>
import DatePick from "vue-date-pick";
import "vue-date-pick/dist/vueDatePick.css";
import axios from "axios";
export default {
  components: { DatePick },
  data() {
    return {
      prepaidProductPriceObj: [],
      promoVerifyObj: [],
      subscriptionVerificationObj: [],
      userId: 0,
      productId: 0,
      subscriptionId: 0,
      productName: "",
      productImageUrl: "",
      subscriptionType: "",
      subscriptionTypeDaily: false,
      subscriptionTypeBoth: false,
      subscriptionTypeOneTime: false,
      alternateDisplay: false,
      customizeDisplay: false,
      productShortDescription: "",
      productLongDescription: "",
      isEditSubscription: true,
      brandName: "",
      subDate: "2019-08-27",
      quantityValue: 1,
      maxQuantity: 5,
      selectedAlternate: 2,
      selectedDayId: "sun",
      alternateOptions: [
        {
          value: "2",
          text: "Every 2nd Day",
        },
        {
          value: "3",
          text: "Every 3rd Day",
        },
        {
          value: "4",
          text: "Every 4th Day",
        },
      ],
      sunQty: 1,
      monQty: 1,
      tueQty: 1,
      wedQty: 1,
      thuQty: 1,
      friQty: 1,
      satQty: 1,
      fillSunColor: false,
      closePromo: true,
      closeNiceTohave: true,
      isFullPage: true,
      isLoading: true,
      subPaymentMode: "Prepaid",
      promocodeText: "",
      nicetohavereqText: "",
      prepaidCheckbox: true,
      postpaidCheckbox: false,
      everydayCheckbox: true,
      customizeCheckbox: false,
      alternateCheckbox: false,
      onetimeCheckbox: false,
      descAngleDown: true,
      ringOnNotSelected: false,
      ringOnSelected: true,
      ringOffNotSelected: true,
      ringOffSelected: false,
      isPostpaidDisabled: false,
      promoCodeSuccess: false,
      promoCodeFailed: false,
      promoCodeVerifyMsg: "",
      promoCodeVerified: false,
      promoCodeVerifiedDirectLink: false,
      productPriceId: 0,
      displayPromocodeText: "",
      displayedDate: "",
      directLinkOfferedDiscount: 0,
      cutPrice: false,
    };
  },
  created() {
    // sessionStorage.setItem('paymentFlow', 'productList')
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.userId = sessionStorage.getItem("userId");
      this.productId = sessionStorage.getItem("productId");
      this.productName = sessionStorage.getItem("productName");
      this.productImageUrl = sessionStorage.getItem("productImageUrl");
      this.productShortDescription = sessionStorage.getItem(
        "productShortDescription"
      );
      this.productLongDescription = sessionStorage.getItem(
        "productLongDescription"
      );
      this.brandName = sessionStorage.getItem("brandName");
      this.isEditSub = sessionStorage.getItem("isEditSubscription");
      if (this.isEditSub === "yes") {
        this.isEditSubscription = true;
      } else {
        this.isEditSubscription = false;
      }
      this.subscriptionId = sessionStorage.getItem("subscriptionId");
      this.subscriptionType = sessionStorage.getItem("subscriptionType");
      this.subscriptionTypeDaily = false;
      this.subscriptionTypeBoth = false;
      this.subscriptionTypeOneTime = false;
      if (this.subscriptionType === "Daily") {
        this.subscriptionTypeDaily = true;
      } else if (this.subscriptionType === "Both") {
        this.subscriptionTypeBoth = true;
      } else {
        this.subscriptionTypeOneTime = true;
      }
      const params = new URLSearchParams();
      params.append("user_id", this.userId);
      params.append("product_id", this.productId);
      axios({
        url: process.env.BASE_API + "/subscriptions/prepaid-product-price",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          // console.log(response)
          // debugger
          this.prepaidProductPriceObj = {};
          this.prepaidProductPriceObj.pincode = response.data.pincode;
          this.prepaidProductPriceObj.postpaidPrice =
            response.data.postpaid_price;
          this.prepaidProductPriceObj.prepaidPrice =
            response.data.prepaid_price;
          this.prepaidProductPriceObj.postpaidPrice = parseFloat(
            Math.round(this.prepaidProductPriceObj.postpaidPrice * 100) / 100
          ).toFixed(2);
          this.prepaidProductPriceObj.prepaidPrice = parseFloat(
            Math.round(this.prepaidProductPriceObj.prepaidPrice * 100) / 100
          ).toFixed(2);
          this.prepaidProductPriceObj.flat_discount_mrp_applicable =
            response.data.flat_discount_mrp_applicable;
          this.prepaidProductPriceObj.prodQuantity = response.data.quantity;
          this.prepaidProductPriceObj.prodUnit = response.data.unit;
          sessionStorage.setItem(
            "prodBaseQuantity",
            this.prepaidProductPriceObj.prodQuantity
          );
          sessionStorage.setItem(
            "prodUnit",
            this.prepaidProductPriceObj.prodUnit
          );
          this.prepaidProductPriceObj.subStartDate =
            response.data.sub_start_date;
          this.maxQuantity = response.data.prod_max_order_quantity;
          if (sessionStorage.getItem("subDate")) {
            this.subDate = sessionStorage.getItem("subDate");
          } else {
            this.subDate = this.prepaidProductPriceObj.subStartDate;
          }
          if (sessionStorage.getItem("subPaymentMode")) {
            this.subPaymentMode = sessionStorage.getItem("subPaymentMode");
          } else {
            this.subPaymentMode = response.data.default_subscription;
          }
          if (sessionStorage.getItem("prodQuantity")) {
            this.quantityValue = sessionStorage.getItem("prodQuantity");
          } else {
            this.quantityValue = this.prepaidProductPriceObj.prodQuantity;
          }
          this.productPriceId = response.data.product_price_id;
          if (sessionStorage.getItem("ringOnSelected") === "true") {
            this.ringOnNotSelected = false;
            this.ringOnSelected = true;
            this.ringOffNotSelected = true;
            this.ringOffSelected = false;
          } else if (
            response.data.bell_status === 0 ||
            sessionStorage.getItem("ringOnSelected") === "false"
          ) {
            this.ringOnNotSelected = true;
            this.ringOnSelected = false;
            this.ringOffNotSelected = false;
            this.ringOffSelected = true;
          } else {
          }
          if (sessionStorage.getItem("nice_to_have_req")) {
            this.nicetohavereqText = sessionStorage.getItem("nice_to_have_req");
            this.closeNiceTohave = false;
          } else {
            this.nicetohavereqText = response.data.nice_to_have_req;
          }
          /* if (this.nicetohavereqText !== '') {
            this.closeNiceTohave = false
          } */
          /* let postpaidDisabled = response.data.is_postpaid_disabled
          if (postpaidDisabled === 1) {
            this.isPostpaidDisabled = true
          } else {
            this.isPostpaidDisabled = false
          } */
          switch (sessionStorage.getItem("scheduleText")) {
            case "Everyday":
              this.everydayCheckbox = true;
              this.customizeCheckbox = false;
              this.alternateCheckbox = false;
              break;
            case "Customize":
              this.everydayCheckbox = false;
              this.customizeCheckbox = true;
              this.customizeDisplay = true;
              this.alternateCheckbox = false;
              if (sessionStorage.getItem("monQty")) {
                this.monQty = sessionStorage.getItem("monQty");
              }
              if (sessionStorage.getItem("tueQty")) {
                this.tueQty = sessionStorage.getItem("tueQty");
              }
              if (sessionStorage.getItem("wedQty")) {
                this.wedQty = sessionStorage.getItem("wedQty");
              }
              if (sessionStorage.getItem("thuQty")) {
                this.thuQty = sessionStorage.getItem("thuQty");
              }
              if (sessionStorage.getItem("friQty")) {
                this.friQty = sessionStorage.getItem("friQty");
              }
              if (sessionStorage.getItem("satQty")) {
                this.satQty = sessionStorage.getItem("satQty");
              }
              if (sessionStorage.getItem("sunQty")) {
                this.sunQty = sessionStorage.getItem("sunQty");
              }
              break;
            case "Alternate":
              this.everydayCheckbox = false;
              this.customizeCheckbox = false;
              this.alternateCheckbox = true;
              this.alternateDisplay = true;
              this.selectedAlternate = sessionStorage.getItem("alternate");
              break;
            default:
              if (this.subscriptionTypeOneTime === false) {
                document.getElementById("everydayid").checked = true;
              } else {
                this.everydayCheckbox = false;
                this.customizeCheckbox = false;
                this.alternateCheckbox = false;
              }
              break;
          }
          if (this.subPaymentMode === "Prepaid") {
            this.prepaidCheckbox = true;
            this.postpaidCheckbox = false;
          } else {
            this.prepaidCheckbox = false;
            this.postpaidCheckbox = true;
          }
          // alert(this.isEditSubscription)
          if (this.isEditSubscription === true) {
            this.editSubscription();
          } else {
            if (
              this.productId === "128" ||
              this.productId === "129" ||
              this.productId === 128 ||
              this.productId === 129 ||
              this.productId === "151" ||
              this.productId === 151
            ) {
              this.quantityValue = 2;
            }
            this.isLoading = false;
          }
          let postpaidDisabled = response.data.is_postpaid_disabled;
          if (postpaidDisabled === 1) {
            this.isPostpaidDisabled = true;
            this.prepaidCheckbox = true;
            this.postpaidCheckbox = false;
            this.subPaymentMode = "Prepaid";
          } else {
            this.isPostpaidDisabled = false;
          }
          // debugger
          if (sessionStorage.getItem("promocodeName") !== null) {
            this.promocodeText = sessionStorage.getItem("promocodeName");
            this.displayPromocodeText = sessionStorage.getItem("promocodeDesc");
            this.promoCodeVerified = true;
            this.promoCodeVerifiedDirectLink = true;
            if (sessionStorage.getItem("directLinkOfferedDiscount") > 0) {
              this.directLinkOfferedDiscount = parseFloat(
                sessionStorage.getItem("directLinkOfferedDiscount")
              );
              this.directLinkOfferedDiscount =
                this.directLinkOfferedDiscount.toFixed(2);
              this.cutPrice = true;
            }
          } else if (response.data.flat_discount_mrp_applicable === true) {
            this.cutPrice = true;
            this.prepaidProductPriceObj.postpaid_price_without_offer =
              response.data.postpaid_price_without_offer;
            this.prepaidProductPriceObj.prepaid_price_without_offer =
              response.data.prepaid_price_without_offer;
            this.prepaidProductPriceObj.postpaid_price_without_offer =
              parseFloat(
                Math.round(
                  this.prepaidProductPriceObj.postpaid_price_without_offer * 100
                ) / 100
              ).toFixed(2);
            this.prepaidProductPriceObj.prepaid_price_without_offer =
              parseFloat(
                Math.round(
                  this.prepaidProductPriceObj.prepaid_price_without_offer * 100
                ) / 100
              ).toFixed(2);
          }

          // console.log(this.directLinkOfferedDiscount)
          // this.isLoading = false
          /* if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          } */
        })
        .catch((e) => {
          alert("not ok");
        });
    },

    isServicePincode() {
      if (sessionStorage.getItem("dispatcherId") !== null) {
        this.subscriptionVerification();
      } else {
        const params = new URLSearchParams();
        params.append("user_id", this.userId);
        params.append("pincode", this.prepaidProductPriceObj.pincode);
        axios({
          url: process.env.BASE_API + "/subscriptions/is-service-pincode",
          method: "post",
          data: params,
          withCredentials: false,
          headers: {},
        })
          .then((response) => {
            let str = response.data.msg;
            if (response.data.status === "000000") {
              this.subscriptionVerification();
            } else {
              this.$swal({
                text: str,
                showCancelButton: true,
                confirmButtonText: "Update Address",
                cancelButtonText: "Cancel",
                // showCloseButton: true,
                // showLoaderOnConfirm: true
              }).then((result) => {
                if (result.value) {
                  this.locationModule();
                } else {
                  // nothing
                }
              });
            }
          })
          .catch((e) => {
            alert("not ok");
          });
      }
    },

    locationModule() {
      // alert('location')
      sessionStorage.setItem("userId", this.userId);
      sessionStorage.setItem("isProfile", 1);
      sessionStorage.setItem("actionName", "subscription");
      sessionStorage.setItem("callbackUrlForSubscription", document.URL);
      sessionStorage.setItem("locationAction", "getOldLocation");
      this.$router.push("/a/location");
    },

    editSubscription() {
      const params = new URLSearchParams();
      params.append("subscription_id", this.subscriptionId);
      axios({
        url: process.env.BASE_API + "/subscriptions/edit-subscription",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          // debugger
          // console.log(response)
          // this.subPaymentMode = response.data.edit_subscription.subscription_type
          this.subDate = response.data.edit_subscription.start_date;
          this.displayedDate = this.subDate.split("-").reverse().join("-");
          // alert(this.subPaymentMode)
          if (sessionStorage.getItem("subPaymentMode")) {
            this.subPaymentMode = sessionStorage.getItem("subPaymentMode");
          } else {
            this.subPaymentMode =
              response.data.edit_subscription.subscription_type;
          }
          if (sessionStorage.getItem("ringOnSelected") === "true") {
            this.ringOnNotSelected = false;
            this.ringOnSelected = true;
            this.ringOffNotSelected = true;
            this.ringOffSelected = false;
          } else if (
            response.data.edit_subscription.bell_status === 0 ||
            sessionStorage.getItem("ringOnSelected") === "false"
          ) {
            this.ringOnNotSelected = true;
            this.ringOnSelected = false;
            this.ringOffNotSelected = false;
            this.ringOffSelected = true;
          } else {
          }
          if (sessionStorage.getItem("nice_to_have_req")) {
            this.nicetohavereqText = sessionStorage.getItem("nice_to_have_req");
            this.closeNiceTohave = false;
          } else {
            this.nicetohavereqText =
              response.data.edit_subscription.nice_to_have_req;
          }
          if (this.nicetohavereqText !== "") {
            this.closeNiceTohave = false;
          }
          if (this.subPaymentMode === "Prepaid") {
            this.prepaidCheckbox = true;
            this.postpaidCheckbox = false;
          } else {
            this.prepaidCheckbox = false;
            this.postpaidCheckbox = true;
          }

          if (response.data.edit_subscription["promo-status"] === "Valid") {
            this.displayPromocodeText =
              "*Promo code discount Rs " +
              response.data.edit_subscription["offer-amount"].toFixed(2) +
              "/- expire on " +
              response.data.edit_subscription.expire_date +
              ".";
          }
          if (response.data.edit_subscription["promo-status"] === "Expired") {
            this.displayPromocodeText =
              "*Your promo code expired on " +
              response.data.edit_subscription.expire_date +
              ".";
          }
          /* this.subscriptionTypeBoth = false
          this.subscriptionTypeOneTime = false
          // alert(response.data.edit_subscription.type)
          if (response.data.edit_subscription.type === 'Daily') {
            this.subscriptionTypeBoth = true
          } else {
            this.subscriptionTypeOneTime = true
          } */
          /* this.subscriptionTypeDaily = false
          this.subscriptionTypeBoth = false
          this.subscriptionTypeOneTime = false
          if (response.data.edit_subscription.type === 'Daily') {
            this.subscriptionTypeDaily = true
          } else if (response.data.edit_subscription.type === 'Both') {
            this.subscriptionTypeBoth = true
          } else {
            this.subscriptionTypeOneTime = true
          } */
          if (this.subscriptionTypeOneTime === false) {
            document.getElementById("everydayid").checked = true;
          } else {
            this.everydayCheckbox = false;
            this.customizeCheckbox = false;
            this.alternateCheckbox = false;
          }
          this.everydayCheckbox = false;
          this.customizeCheckbox = false;
          this.alternateCheckbox = false;
          this.onetimeCheckbox = false;
          if (
            response.data.edit_subscription.delivery_frequency === "3" &&
            response.data.edit_subscription.type === "Daily"
          ) {
            this.everydayCheckbox = true;
            this.quantityValue = response.data.edit_subscription.quantity;
          } else if (
            response.data.edit_subscription.delivery_frequency === "1"
          ) {
            this.customizeCheckbox = true;
            this.customizeDisplay = true;
            this.sunQty = response.data.edit_subscription.sunday;
            this.monQty = response.data.edit_subscription.monday;
            this.tueQty = response.data.edit_subscription.tuesday;
            this.wedQty = response.data.edit_subscription.wednesday;
            this.thuQty = response.data.edit_subscription.thursday;
            this.friQty = response.data.edit_subscription.friday;
            this.satQty = response.data.edit_subscription.saturday;
            this.selectedDayId = "sun";
            this.quantityValue = this.sunQty;
            this.fillSunColor = true;
            if (document.getElementById("sun")) {
              document.getElementById("sun").style.backgroundColor = "white";
              document.getElementById("mon").style.backgroundColor = "white";
              document.getElementById("tue").style.backgroundColor = "white";
              document.getElementById("wed").style.backgroundColor = "white";
              document.getElementById("thu").style.backgroundColor = "white";
              document.getElementById("fri").style.backgroundColor = "white";
              document.getElementById("sat").style.backgroundColor = "white";
              document.getElementById("sun").style.color = "#5e5a57";
              document.getElementById("mon").style.color = "#5e5a57";
              document.getElementById("tue").style.color = "#5e5a57";
              document.getElementById("wed").style.color = "#5e5a57";
              document.getElementById("thu").style.color = "#5e5a57";
              document.getElementById("fri").style.color = "#5e5a57";
              document.getElementById("sat").style.color = "#5e5a57";
              document.getElementById("sun").style.backgroundColor = "#3CB6C3";
              document.getElementById("sun").style.color = "white";
            }
          } else if (
            response.data.edit_subscription.delivery_frequency === "2"
          ) {
            this.alternateDisplay = true;
            this.alternateCheckbox = true;
            this.quantityValue = response.data.edit_subscription.quantity;
            this.selectedAlternate = response.data.edit_subscription.alternate;
          } else {
            this.onetimeCheckbox = true;
            this.quantityValue = response.data.edit_subscription.quantity;
          }
          switch (sessionStorage.getItem("scheduleText")) {
            case "Everyday":
              this.everydayCheckbox = true;
              this.customizeCheckbox = false;
              this.alternateCheckbox = false;
              break;
            case "Customize":
              this.everydayCheckbox = false;
              this.customizeCheckbox = true;
              this.customizeDisplay = true;
              this.alternateCheckbox = false;
              if (sessionStorage.getItem("monQty")) {
                this.monQty = sessionStorage.getItem("monQty");
              }
              if (sessionStorage.getItem("tueQty")) {
                this.tueQty = sessionStorage.getItem("tueQty");
              }
              if (sessionStorage.getItem("wedQty")) {
                this.wedQty = sessionStorage.getItem("wedQty");
              }
              if (sessionStorage.getItem("thuQty")) {
                this.thuQty = sessionStorage.getItem("thuQty");
              }
              if (sessionStorage.getItem("friQty")) {
                this.friQty = sessionStorage.getItem("friQty");
              }
              if (sessionStorage.getItem("satQty")) {
                this.satQty = sessionStorage.getItem("satQty");
              }
              if (sessionStorage.getItem("sunQty")) {
                this.sunQty = sessionStorage.getItem("sunQty");
              }
              break;
            case "Alternate":
              this.everydayCheckbox = false;
              this.customizeCheckbox = false;
              this.alternateCheckbox = true;
              this.alternateDisplay = true;
              this.selectedAlternate = sessionStorage.getItem("alternate");
              break;
            default:
              if (this.subscriptionTypeOneTime === false) {
                document.getElementById("everydayid").checked = true;
              } else {
                this.everydayCheckbox = false;
                this.customizeCheckbox = false;
                this.alternateCheckbox = false;
              }
              break;
          }
          if (sessionStorage.getItem("prodQuantity")) {
            this.quantityValue = sessionStorage.getItem("prodQuantity");
          } else {
            this.quantityValue = response.data.edit_subscription.quantity;
          }
          this.isLoading = false;
        })
        .catch((e) => {
          alert("not ok");
        });
    },

    paymentMode(event) {
      let checkId = event.srcElement.offsetParent.id;
      // console.log(checkId)
      this.prepaidCheckbox = false;
      this.postpaidCheckbox = false;
      if (checkId === "prepaidB") {
        this.prepaidCheckbox = true;
        this.subPaymentMode = "Prepaid";
      } else {
        this.postpaidCheckbox = true;
        this.subPaymentMode = "Postpaid";
      }
    },

    descriptionClick(event) {
      if (this.descAngleDown === true) {
        this.descAngleDown = false;
      } else {
        this.descAngleDown = true;
      }
    },

    checkPromoValid() {
      // debugger
      if (this.promocodeText !== "") {
        const params = new URLSearchParams();
        params.append("user_id", this.userId);
        params.append("product_id", this.productId);
        params.append("promo_code", this.promocodeText);
        axios({
          url: process.env.BASE_API + "/subscriptions/promo-verify",
          method: "post",
          data: params,
          withCredentials: false,
          headers: {},
        })
          .then((response) => {
            // console.log(response)
            this.promoVerifyObj = {};
            if (response.data.status === "000000") {
              this.promoCodeSuccess = true;
              this.promoCodeFailed = false;
              this.promoCodeVerified = true;
            } else {
              this.promoCodeFailed = true;
              this.promoCodeSuccess = false;
            }
            this.promoCodeVerifyMsg = response.data.msg;
            // console.log(response)
            this.isLoading = false;
            /* if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
              this.list = response.data.user_record
              alert(this.list)
            } */
          })
          .catch((e) => {
            alert("not ok");
          });
      }
    },

    schedulePlan(event) {
      this.quantityValue = 1;
      this.fillSunColor = false;
      this.alternateDisplay = false;
      this.customizeDisplay = false;
      let checkId = event.srcElement.offsetParent.id;
      // console.log(checkId)
      this.everydayCheckbox = false;
      this.customizeCheckbox = false;
      this.alternateCheckbox = false;
      this.onetimeCheckbox = false;
      if (checkId === "everydayid") {
        this.everydayCheckbox = true;
      } else if (checkId === "customizeid") {
        this.customizeCheckbox = true;
        this.customizeDisplay = true;
        this.sunQty = 1;
        this.monQty = 1;
        this.tueQty = 1;
        this.wedQty = 1;
        this.thuQty = 1;
        this.friQty = 1;
        this.satQty = 1;
        this.selectedDayId = "sun";
        // this.quantityValue = this.sunQty
        this.fillSunColor = true;
        if (document.getElementById("sun")) {
          document.getElementById("sun").style.backgroundColor = "white";
          document.getElementById("mon").style.backgroundColor = "white";
          document.getElementById("tue").style.backgroundColor = "white";
          document.getElementById("wed").style.backgroundColor = "white";
          document.getElementById("thu").style.backgroundColor = "white";
          document.getElementById("fri").style.backgroundColor = "white";
          document.getElementById("sat").style.backgroundColor = "white";
          document.getElementById("sun").style.color = "#5e5a57";
          document.getElementById("mon").style.color = "#5e5a57";
          document.getElementById("tue").style.color = "#5e5a57";
          document.getElementById("wed").style.color = "#5e5a57";
          document.getElementById("thu").style.color = "#5e5a57";
          document.getElementById("fri").style.color = "#5e5a57";
          document.getElementById("sat").style.color = "#5e5a57";
          document.getElementById("sun").style.backgroundColor = "#3CB6C3";
          document.getElementById("sun").style.color = "white";
        }
      } else if (checkId === "alternateid") {
        this.alternateDisplay = true;
        this.alternateCheckbox = true;
      } else {
        this.onetimeCheckbox = true;
      }
    },

    customizeDivColor(event) {
      // console.log(event.toElement.id)
      document.getElementById("sun").style.backgroundColor = "white";
      document.getElementById("mon").style.backgroundColor = "white";
      document.getElementById("tue").style.backgroundColor = "white";
      document.getElementById("wed").style.backgroundColor = "white";
      document.getElementById("thu").style.backgroundColor = "white";
      document.getElementById("fri").style.backgroundColor = "white";
      document.getElementById("sat").style.backgroundColor = "white";
      document.getElementById("sun").style.color = "#5e5a57";
      document.getElementById("mon").style.color = "#5e5a57";
      document.getElementById("tue").style.color = "#5e5a57";
      document.getElementById("wed").style.color = "#5e5a57";
      document.getElementById("thu").style.color = "#5e5a57";
      document.getElementById("fri").style.color = "#5e5a57";
      document.getElementById("sat").style.color = "#5e5a57";
      let dayId = event.target.id;
      document.getElementById(dayId).style.backgroundColor = "#3CB6C3";
      document.getElementById(dayId).style.color = "white";
      if (dayId === "sun") {
        this.quantityValue = this.sunQty;
      } else if (dayId === "mon") {
        this.quantityValue = this.monQty;
      } else if (dayId === "tue") {
        this.quantityValue = this.tueQty;
      } else if (dayId === "wed") {
        this.quantityValue = this.wedQty;
      } else if (dayId === "thu") {
        this.quantityValue = this.thuQty;
      } else if (dayId === "fri") {
        this.quantityValue = this.friQty;
      } else {
        this.quantityValue = this.satQty;
      }
      this.selectedDayId = dayId;
    },

    promocode(event) {
      let promoId = event.target.id;
      console.log(promoId);
      if (promoId === "closePromocode" || promoId === "closePromocode1") {
        this.closePromo = false;
      } else {
        this.closePromo = true;
        this.promoCodeSuccess = false;
        this.promoCodeFailed = false;
        this.promocodeText = "";
        this.promoCodeVerified = false;
      }
    },

    nicetohavereq(event) {
      let nicetohaveId = event.target.id;
      if (
        nicetohaveId === "closeNiceToHaveRequest" ||
        nicetohaveId === "closeNiceToHaveRequest1"
      ) {
        this.closeNiceTohave = false;
      } else {
        this.closeNiceTohave = true;
      }
    },

    bellStatusChange(event) {
      this.ringOnNotSelected = false;
      this.ringOnSelected = false;
      this.ringOffNotSelected = false;
      this.ringOffSelected = false;
      let bellId = event.target.id;
      // console.log(event)
      if (bellId === "ring_on_not_selected") {
        this.ringOnNotSelected = false;
        this.ringOnSelected = true;
        this.ringOffNotSelected = true;
        this.ringOffSelected = false;
      } else if (bellId === "ring_on_selected") {
        this.ringOnNotSelected = false;
        this.ringOnSelected = true;
        this.ringOffNotSelected = true;
        this.ringOffSelected = false;
      } else if (bellId === "ring_on_not_selected") {
        this.ringOnNotSelected = true;
        this.ringOnSelected = false;
        this.ringOffNotSelected = false;
        this.ringOffSelected = true;
      } else {
        this.ringOnNotSelected = true;
        this.ringOnSelected = false;
        this.ringOffNotSelected = false;
        this.ringOffSelected = true;
      }
    },

    changeQuantity(newValue) {
      // console.productLongDescriptiong(newValue)
      if (this.customizeDisplay === true) {
        // this.sunQty = newValue
        if (this.selectedDayId === "sun") {
          this.sunQty = newValue;
        } else if (this.selectedDayId === "mon") {
          this.monQty = newValue;
        } else if (this.selectedDayId === "tue") {
          this.tueQty = newValue;
        } else if (this.selectedDayId === "wed") {
          this.wedQty = newValue;
        } else if (this.selectedDayId === "thu") {
          this.thuQty = newValue;
        } else if (this.selectedDayId === "fri") {
          this.friQty = newValue;
        } else {
          this.satQty = newValue;
        }
        // this.selectedDayId = dayId
      }
    },

    subscriptionVerification() {
      /* alert('user_id' + this.userId)
      alert('product_id' + this.productId)
      alert('start_date' + this.subDate)
      alert('subscription_type' + this.subPaymentMode)
      alert('quantity' + this.quantityValue) */
      /* alert('everydayCheckbox' + this.everydayCheckbox)
      alert('customizeCheckbox' + this.customizeCheckbox)
      alert('alternateCheckbox' + this.alternateCheckbox) */
      if (
        this.customizeCheckbox === true &&
        this.monQty === 0 &&
        this.tueQty === 0 &&
        this.wedQty === 0 &&
        this.thuQty === 0 &&
        this.friQty === 0 &&
        this.satQty === 0 &&
        this.sunQty === 0
      ) {
        this.$toast.open({
          message: "Please enter quantity for atleast one day",
          type: "error",
        });
        // this.$swal.fire({text: 'Please enter quantity for atleast one day'})
      } else if (
        this.everydayCheckbox === true &&
        this.alternateCheckbox === true &&
        this.quantityValue < 1
      ) {
        this.$toast.open({
          message: "Please enter quantity for atleast one day",
          type: "error",
        });
      } else {
        const params = new URLSearchParams();
        if (this.isEditSubscription === true) {
          params.append("isUpdate", 1);
          params.append("subscription_id", this.subscriptionId);
        }
        params.append("user_id", this.userId);
        params.append("product_id", this.productId);
        params.append("start_date", this.subDate);
        params.append("subscription_type", this.subPaymentMode);
        sessionStorage.setItem("subPaymentMode", this.subPaymentMode);
        sessionStorage.setItem("subDate", this.subDate);
        params.append("product_price_id", this.productPriceId);
        if (this.ringOnSelected === true) {
          params.append("is_ring_bell", 1);
        } else {
          params.append("is_ring_bell", 0);
        }
        sessionStorage.setItem("ringOnSelected", this.ringOnSelected);
        params.append("nice_to_have_req", this.nicetohavereqText);
        sessionStorage.setItem("nice_to_have_req", this.nicetohavereqText);
        if (this.everydayCheckbox === true) {
          sessionStorage.setItem("scheduleText", "Everyday");
          params.append("type", "Daily");
          params.append("delivery_frequency", 3);
          params.append("quantity", this.quantityValue);
        } else if (this.customizeCheckbox === true) {
          sessionStorage.setItem("scheduleText", "Customize");
          params.append("type", "Daily");
          params.append("delivery_frequency", 1);
          params.append("monday", this.monQty);
          params.append("tuesday", this.tueQty);
          params.append("wednesday", this.wedQty);
          params.append("thursday", this.thuQty);
          params.append("friday", this.friQty);
          params.append("saturday", this.satQty);
          params.append("sunday", this.sunQty);
          sessionStorage.setItem("monQty", this.monQty);
          sessionStorage.setItem("tueQty", this.tueQty);
          sessionStorage.setItem("wedQty", this.wedQty);
          sessionStorage.setItem("thuQty", this.thuQty);
          sessionStorage.setItem("friQty", this.friQty);
          sessionStorage.setItem("satQty", this.satQty);
          sessionStorage.setItem("sunQty", this.sunQty);
        } else if (this.alternateCheckbox === true) {
          sessionStorage.setItem("scheduleText", "Alternate");
          params.append("type", "Daily");
          params.append("delivery_frequency", 2);
          params.append("quantity", this.quantityValue);
          params.append("alternate", this.selectedAlternate);
          sessionStorage.setItem("alternate", this.selectedAlternate);
        } else {
          // for one time
          sessionStorage.setItem("scheduleText", "One Time");
          params.append("type", "One Time");
          params.append("delivery_frequency", 3);
          params.append("quantity", this.quantityValue);
        }
        if (this.isPostpaidDisabled === true) {
          sessionStorage.setItem("isPostpaidDisabled", "yes");
        } else {
          sessionStorage.setItem("isPostpaidDisabled", "no");
        }
        if (this.promoCodeVerified === true) {
          sessionStorage.setItem("promoCodeVerified", "yes");
          sessionStorage.setItem("promocodeText", this.promocodeText);
          params.append("promo_code", this.promocodeText);
        } else {
          sessionStorage.setItem("promoCodeVerified", "no");
          sessionStorage.setItem("promocodeText", "");
        }
        sessionStorage.setItem("prodQuantity", this.quantityValue);
        axios({
          url:
            process.env.BASE_API + "/subscriptions/subscription-verification",
          method: "post",
          data: params,
          withCredentials: false,
          headers: {},
        })
          .then((response) => {
            // console.log(response)
            let str = response.data.msg;
            str = str.replace("EMOJI_ONE", process.env.EMOJI_ONE);
            str = str.replace("EMOJI_TWO", process.env.EMOJI_TWO);
            str = str.replace("EMOJI_THREE", process.env.EMOJI_THREE);
            this.subscriptionVerificationObj = {};
            // debugger
            if (response.data.msg_type === "msg_no_msg") {
              sessionStorage.setItem(
                "paymentModeText",
                response.data.payment_mode_text
              );
              sessionStorage.setItem(
                "isReferrerDisplay",
                response.data.is_referrer_dispaly
              );
              let subDetail = JSON.stringify(
                response.data.subscription_details
              );
              this.$router.push({
                path: "/a/subscriptionVerification",
                query: { cn: btoa(subDetail) },
              });
            } else if (response.data.msg_type === "msg_warning") {
              // alert(str)
              this.$swal({
                title: "Warning!",
                text: str,
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Replan",
                cancelButtonText: "Continue",
                // showCloseButton: true,
                // showLoaderOnConfirm: true
              }).then((result) => {
                if (result.value) {
                  // this.$swal('Success', 'Thanks you Replan!', 'success')
                } else {
                  sessionStorage.setItem(
                    "paymentModeText",
                    response.data.payment_mode_text
                  );
                  sessionStorage.setItem(
                    "isReferrerDisplay",
                    response.data.is_referrer_dispaly
                  );
                  let subDetail = JSON.stringify(
                    response.data.subscription_details
                  );
                  this.$router.push({
                    path: "/a/subscriptionVerification",
                    query: { cn: btoa(subDetail) },
                  });
                }
              });
            } else if (
              response.data.msg_type === "msg_error" &&
              response.data.error_code === "000005"
            ) {
              // alert(str)
              this.$swal({
                title: "Warning!",
                text: str,
                type: "error",
                showCancelButton: true,
                confirmButtonText: "Recharge",
                cancelButtonText: "Cancel",
                // showCloseButton: true,
                // showLoaderOnConfirm: true
              }).then((result) => {
                if (result.value) {
                  params.append("action_name", "order_flow_payment_url");
                  params.append("user_id", this.userId);
                  params.append(
                    "required_amount",
                    response.data.default_amount
                  );
                  axios({
                    url: process.env.BASE_API + "/users/invoke-user-action",
                    method: "post",
                    data: params,
                    withCredentials: false,
                    headers: {},
                  })
                    .then((response) => {
                      sessionStorage.setItem("paymentFlow", "payment");
                      // console.log(response)
                      window.location.href = response.data.payment_url;
                      /*  var fullUrl = response.data.payment_url;
                      var splitUrl = fullUrl.split("pp?");
                      window.location.href =
                        "http://localhost:4000/a/pp?" + splitUrl[1]; */
                      // window.location.href = 'https://t.doodhvale.in/#/a/pp?' + splitUrl[1]
                    })
                    .catch((e) => {
                      alert("not ok");
                    });
                } else {
                  // this.$swal('Success', 'Thanks you Replan!', 'success')
                }
              });
            } else {
              // alert(response.data.msg)
              // alert(str)
              this.$swal({
                title: "Sorry!",
                text: str + "!",
                type: "warning",
                showCancelButton: false,
                confirmButtonText: "Okay",
                // showCloseButton: true,
                // showLoaderOnConfirm: true
              }).then((result) => {});
            }
          })
          .catch((e) => {
            alert("not ok");
          });
      }
    },

    isPastDate(date) {
      // let today = new Date()
      let dd = String(date.getDate()).padStart(2, "0");
      let mm = String(date.getMonth() + 1).padStart(2, "0");
      let yyyy = date.getFullYear();
      let selectedDate = yyyy + "-" + mm + "-" + dd;
      if (selectedDate < this.prepaidProductPriceObj.subStartDate) {
        return date;
      }
    },
  },
};
</script>
<style>
#editSub .columns {
  margin: 0.5rem 0 0 0 !important;
}

#editSub .column {
  padding: 0 0 1rem 0 !important;
}

#editSub .productImageOnEditSubscription {
  height: 100px;
  width: 100px;
  border-radius: 50%;
  margin-left: 10%;
}

#editSub .panel:not(:last-child) {
  margin-bottom: 0.5rem;
}

#editSub .topMargin {
  /*margin-top: .5rem;*/
  margin-top: 1rem;
}

#editSub .topMarginHalf {
  margin-top: 0.5rem;
}

#editSub .bottomMargin {
  margin-bottom: 1.5rem;
}

#editSub .leftMargin {
  margin-left: 5%;
}

#editSub .rightMargin {
  margin-right: 5%;
}

#editSub .vdpArrowPrev:after {
  border-right-color: #3cb6c3 !important;
}

#editSub .vdpArrowNext:after {
  border-left-color: #3cb6c3 !important;
}

#editSub .vdpCell.selectable:hover .vdpCellContent,
#editSub .vdpCell.selected .vdpCellContent {
  background: #3cb6c3 !important;
}

#editSub .vdpTimeUnit > input:hover,
#editSub .vdpTimeUnit > input:focus {
  border-bottom-color: #3cb6c3 !important;
}

#editSub .vdpClearInput {
  display: none !important;
}

#editSub .vdpComponent.vdpWithInput > input {
  padding-right: 0px !important;
}

#editSub .vue-numeric-input .btn-decrement {
  left: 2px !important;
  top: 2px !important;
  bottom: 2px !important;
  border-width: 1px !important;
  border-radius: 50% !important;
}

#editSub .vue-numeric-input .btn-increment {
  right: 2px !important;
  top: 2px !important;
  bottom: 2px !important;
  border-width: 1px !important;
  border-radius: 50% !important;
}

#editSub .vue-numeric-input .numeric-input {
  padding-right: 1.8rem !important;
  padding-left: 1.8rem !important;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: inherit;
  border: 0px solid #ccc !important;
  border-radius: 2px !important;
  display: block !important;
  line-height: 1.5rem !important;
  width: 100% !important;
}

#editSub .vue-numeric-input .btn {
  /*background: white !important;*/
}

#editSub .btn {
  padding: unset !important;
}

#editSub .customizedays {
  width: 14%;
  float: left;
  text-align: center;
  font-size: 18px;
}

#editSub .customizedaycss {
  width: 58%;
  /*background: #3CB6C3;*/
  border-radius: 50%;
  color: #5e5a57;
  /*font-size: 16px;*/
}

#editSub .b-checkbox.checkbox input[type="checkbox"]:checked + .check {
  background-color: #3cb6c3 !important;
  border-color: #3cb6c3 !important;
}

#editSub .b-checkbox.checkbox:hover input[type="checkbox"] + .check {
  border-color: none !important;
}

#editSub .b-checkbox.checkbox[disabled] {
  opacity: 1;
}

#editSub .checkbox[disabled] {
  color: black;
  cursor: auto !important;
}

#editSub .plusMinus input {
  pointer-events: none;
}

#editSub .colorDesc {
  background-color: #fdfbd2 !important;
}

#editSub .collapseheaderClass {
  background-color: #fdfbd2 !important;
}

#editSub .panel-heading,
.panel-tabs,
.panel-block {
  /*border-top: none !important;
    border-bottom: none !important;
    border-left: none !important;
    border-right: none !important;*/
  /*border-top: 1px solid #dbdbdb !important;
    border-bottom: 1px solid #dbdbdb !important;
    border-left: 1px solid #dbdbdb !important;
    border-right: 1px solid #dbdbdb !important;*/
}

#editSub div.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  padding: 5px;
  background-color: #cae8ca;
  border: 2px solid #4caf50;
}

#editSub .buttonOnEditSubscription {
  background-color: #3cb6c3;
  padding: 2% 17% 2% 18%;
  width: 100%;
  color: white;
  border: none;
}

#editSub .vdpOuterWrap.vdpPositionFixed {
  position: absolute !important;
}

#editSub .vdpHeadCellContent {
  color: #3cb6c3 !important;
}

#editSub table th {
  background: #3cb6c3 !important;
}

#editSub table {
  border: 3px solid #3cb6c3 !important;
}

#editSub table td {
  border-right: white !important;
}

#editSub table tbody tr:nth-child(2n) td {
  background: white !important;
}

#editSub .vdpHeadCellContent {
  color: white !important;
}

#editSub .promoSuccessFailClass {
  height: 35px;
  width: 35px;
}

#row1 {
  display: flex;
  /* flex-wrap: wrap; */
}

#md6 {
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 0px;
  padding-left: 0px;
}
body {
  font-family: calibari !important;
}

.placedPromocode {
  font-weight: bold;
}
.placedPromocode::placeholder {
  font-weight: 400;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/EditSubscription.vue